import { Leaf } from "lucide-react";
import { MARQUEE_ITEMS } from "@/data/site";
import { useLang, TA } from "@/data/i18n";

export default function Marquee() {
  const { lang } = useLang();
  const source = lang === "ta" ? TA.marquee : MARQUEE_ITEMS;
  const row = [...source, ...source];
  return (
    <div data-testid="marquee" className="bg-sun text-leaf overflow-hidden py-4 border-y border-leaf/20">
      <div className="animate-marquee flex w-max items-center">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center shrink-0">
            {row.map((item, i) => (
              <span key={`${half}-${i}`} className="flex items-center gap-6 px-6 font-display font-bold uppercase tracking-[0.15em] text-sm md:text-base whitespace-nowrap">
                {item}
                <Leaf size={16} className="opacity-60" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
